function getHeaderHeight () {
  const style = window.getComputedStyle(document.body)
  const announcementHeight = parseInt(
    style.getPropertyValue('--Announcement_Height'),
    10,
  )
  const headerHeight = parseInt(style.getPropertyValue('--Header_Height'), 10)

  return `${announcementHeight + headerHeight}px`
}

class LooksCard extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.shouldBeVisible()) {
      this.style.display = 'none'
    }
  }

  setupListeners () {
    super.setupListeners()

    this.observerOverlay = new IntersectionObserver(
      this.handleOverlayObservation.bind(this),
      this.observerOptions,
    )
    this.observerOverlay.observe(this.els.overlay.element)

    if (this.els.overlayTrigger) {
      this.els.overlayTrigger.elements.forEach(el =>
        el.addEventListener('click', e => {
          this.onOverlayTrigger()
        }),
      )
    }
  }

  /** @type {IntersectionObserverCallback} */
  handleOverlayObservation (entries) {
    const overlayEntry = entries[0]
    const { intersectionRatio } = overlayEntry

    const shouldShow = entries[0].isIntersecting
    if (shouldShow) {
      this.showOverlay()
      return
    }

    const shouldHide = intersectionRatio === 0
    if (shouldHide) {
      this.hideOverlay()
    }
  }

  showOverlay () {
    const overlayEl = this.els.overlay.element
    const stateCopyEl = this.els.stateCopy.element

    overlayEl.setAttribute('aria-hidden', false)
    stateCopyEl.innerText = stateCopyEl.dataset.visibleCopy
  }

  hideOverlay () {
    const overlayEl = this.els.overlay.element
    const stateCopyEl = this.els.stateCopy.element

    overlayEl.setAttribute('aria-hidden', true)
    stateCopyEl.innerText = stateCopyEl.dataset.hiddenCopy
  }

  onOverlayTrigger () {
    const overlayEl = this.els.overlay.element

    const isOpen = overlayEl.getAttribute('aria-hidden') !== 'true'

    if (isOpen) {
      this.hideOverlay()
    } else {
      this.showOverlay()
    }
  }

  shouldBeVisible () {
    if (!this.dataset.gender) return true

    const currentUrl = new URL(window.location)
    const searchParams = new URLSearchParams(currentUrl.search)

    if (!searchParams.has('gender')) return true

    const gender = this.dataset.gender
    const queryGender = searchParams.get('gender')

    if (gender === 'default' && queryGender === 'female') return true

    if (gender === queryGender || queryGender === 'unisex') return true

    return false
  }

  get showThreshold () {
    /** @type {HTMLElement} */
    const overlay = this.els.overlay.element
    const { height } = overlay.getBoundingClientRect()

    return height <= window.innerHeight ? 1 : 0.25
  }

  /** @returns {IntersectionObserverInit} */
  get observerOptions () {
    return {
      rootMargin: `-${getHeaderHeight()} 0px 0px 0px`,
      threshold: [this.showThreshold, 0],
    }
  }
}

if (!customElements.get('looks-card')) {
  customElements.define('looks-card', LooksCard)
}
